// src/components/ConditionEditor.tsx
import React from 'react';
import { Condition, FormDefinition, Operator, UI_OPERATORS, getAllQuestionIds } from '../../../../interfaces/dynamicForms/FormBuilder';
import { Button } from 'react-bootstrap';
import { unset } from 'lodash';
import "./FormBuilder.css";

interface ConditionEditorProps {
    conditions: Condition[];
    formDefinition: FormDefinition; // Needed to get field IDs
    updateConditions: (newConditions: Condition[]) => void;
    title: string; // e.g., "Show If Conditions"
}

const ConditionEditor: React.FC<ConditionEditorProps> = ({
    conditions = [], // Default to empty array
    formDefinition,
    updateConditions,
    title
}) => {

    const allQuestionIds = getAllQuestionIds(formDefinition);

    const handleConditionChange = (index: number, field: keyof Condition, value: any) => {
        const newConditions = [...conditions];
        // Ensure the condition exists before updating
        if (newConditions[index]) {
            (newConditions[index] as any)[field] = value;
            // If changing operator to/from _ANY, reset value type if needed
            if (field === 'operator' && (value.includes('_ANY') || newConditions[index].operator.includes('_ANY')) ) {
                 newConditions[index].value = value.includes('_ANY') ? [] : '';
            }
             updateConditions(newConditions);
        }
    };

    const addCondition = () => {
        updateConditions([
            ...conditions,
            { field: '', operator: 'EQUALS', value: '' } // Default new condition
        ]);
    };

    const removeCondition = (index: number) => {
        updateConditions(conditions.filter((_, i) => i !== index));
    };

    return (
        <>
            <div className="common_card test" style={{ backgroundColor: 'var(--main-content-bg)' }}>
                <div className="top border_tittle">
                    <div className="top_bar_tittle">
                        <h2>{title} ({conditions.length})</h2>  
                    </div>
                </div>
                {conditions.map((condition, index) => (
                    <div key={index} className="">
                        <div className="row">
                            <div className="col-xl-4 labelBlock">
                                {/* Field Dropdown */}
                                <div className="custom_input_flled">
                                    <label>Field</label>
                                    <select
                                        style={{maxWidth: 'unset'}}
                                        className='sm_input filled_white'
                                        value={condition.field}
                                        onChange={(e) => handleConditionChange(index, 'field', e.target.value)}
                                       >
                                        <option value="">Select Field...</option>
                                        {allQuestionIds.map(id => (
                                            <option key={id} value={id}>{id}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-4 labelBlock">
                                {/* Operator Dropdown */}
                                <div className="custom_input_flled">
                                    <label>Operator</label>
                                    <select style={{maxWidth: 'unset'}} className='sm_input filled_white'
                                        value={condition.operator}
                                        onChange={(e) => handleConditionChange(index, 'operator', e.target.value as Operator)}
                                       >
                                        {UI_OPERATORS.map(op => (
                                            <option key={op} value={op}>{op}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                             <div className="col-xl-4 labelBlock">
                                {/* Value Input */}
                                <div className="custom_input_flled">
                                    <label>Value</label>
                                    {/* Basic input - enhance for multi-value based on operator */}
                                    <input

                                        style={{maxWidth: 'unset'}} className='form-control sm_input filled_white'
                                        type="text"
                                        value={Array.isArray(condition.value) ? condition.value.join(',') : condition.value}
                                        onChange={(e) => handleConditionChange(index, 'value', condition.operator.includes('_ANY') ? e.target.value.split(',') : e.target.value)}
                                        placeholder={condition.operator.includes('_ANY') ? 'value1,value2' : 'Value'}
                                       />
                                </div>
                            </div>
                            {/* Remove Button */}
                        </div>
                        <div className="text-right">
                            <Button variant="danger" className='btn_sm' onClick={() => removeCondition(index)} >Remove</Button>
                        </div>
                    </div>
                ))}
                <div className="mt-4">
                    <Button variant="primary" onClick={addCondition} className="btn_sm">Add Condition</Button>
                </div>
            </div>
        </>
    );
};

export default ConditionEditor;